import { UploadDocumentParams } from "../common/type";
import axiosClient from "./axiosClient";

const documentApi = {
  uploadFile: async (data: UploadDocumentParams) => {
    const formData = new FormData();
    formData.append("name", data.name);
    if (data.subjectId !== undefined) {
      formData.append("subjectId", data.subjectId.toString());
    }
    formData.append("file", data.file);
    if (data.gradeLevel !== undefined) {
      formData.append("gradeLevel", data.gradeLevel.toString());
    }
    if (data.isPrivate !== undefined) {
      formData.append("isPrivate", String(data.isPrivate));
    }

    if (data.emails && data.emails.length > 0) {
      data.emails.forEach(email => {
        formData.append("emails[]", email);
      });
    }
    const res = await axiosClient.post("/documents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    });
    return res;
  },
  getDocumentBySubject: async (params: any) => {
    const res = await axiosClient.get("/subjects/documents", {
      params
    });
    return res;
  },
  downloadDocument: async (fileKey: string) => {
    const res = await axiosClient.get(`/documents/download/${fileKey}`);
    return res;
  },
  deleteDocument: async (id: number) => {
    const res = await axiosClient.delete(`/documents/${id}`);
    return res;
  },
  getPrivateDocumentByUserId: async (userId: number) => {
    const res = await axiosClient.get(`/documents/private/${userId}`);
    return res;
  },
};

export default documentApi;
